import { PortData, PortModel } from 'models/PortModel';
import { ApiBase } from 'utils/api';


export default class PortApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    all = () => this.base.axios
        .get(`/api/ports`)
        .then(res => res.data);

    create = (data: PortData) => this.base.axios
        .post(`/api/ports`, data)
        .then(res => res.data);

    update = (data: PortModel) => this.base.axios
        .put(`/api/ports/${data.id}`, data);

    delete = (id: number) => this.base.axios
        .delete(`/api/ports/${id}`);
}
